<div
  class="status-snack-bar-container"
  [ngClass]="{
    'success-upload-snack-bar': type == Types.SUCCESS,
    'failed-upload-snack-bar': type == Types.FAIL,
    'status-animation': timeout >= 0
  }"
>
  <app-svg-icon class="status-icon" src="./assets/icons/{{ type == Types.SUCCESS ? 'success' : 'failed' }}-status-icon.svg"> </app-svg-icon>

  <div class="message-container">
    <span class="message">{{ message }}</span>
    <span class="submessage"> {{ submessage }} </span>
  </div>
</div>
